// extracted by mini-css-extract-plugin
export default {"attribute":"MobileTableRowAttribute_attribute__POKVi","label":"MobileTableRowAttribute_label__mGPCx","content":"MobileTableRowAttribute_content__QdDTx"};